import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/bg-frames/productions.module.scss';

const propTypes = {
    color: PropTypes.string,
    animate: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#FF6633',
    animate: false,
    className: null,
};

const Productions = ({ color, animate, className }) => (
    <svg
        width="1179"
        height="651"
        viewBox="0 0 1179 651"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames([styles.container, { [className]: className !== null, [styles.animate]: animate }])}
    >
        <g className={styles.rect1}>
            <path
                d="M1178.26 0.129883H0.130859V650.13H1178.26V0.129883Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.rect2}>
            <path
                d="M1117.31 33.98H67.8301V616.27H1117.31V33.98Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.rect3}>
            <path
                d="M1029.29 33.98H149.08V616.27H1029.29V33.98Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.rect4}>
            <path
                d="M981.901 33.98H196.48V616.27H981.901V33.98Z"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.rect5}>
            <path
                d="M47.5195 325.13H88.1495"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.rect6}>
            <path
                d="M1097 325.13H1137.63"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.rect7}>
            <path
                d="M568.881 325.13H609.501"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
        <g className={styles.rect8}>
            <path
                d="M589.189 304.81V345.44"
                stroke={color}
                strokeWidth="0.25"
                strokeMiterlimit="10"
                style={{
                    transform: `translate${Math.random() > 0.5 ? 'X' : 'Y'}(${
                        animate ? 0 : Math.random() * 100 - 100
                    }vw)`,
                    opacity: `${animate ? 1 : 0}`,
                }}
            />
        </g>
    </svg>
);

Productions.propTypes = propTypes;
Productions.defaultProps = defaultProps;

export default Productions;
